var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "c-upload-images",
      attrs: {
        size: "lg",
        title: "Upload images",
        "footer-class": "c-upload-images__footer",
      },
      on: { hide: _vm.closeHandler },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                [
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: { value: "true", "unchecked-value": "false" },
                      model: {
                        value: _vm.isRemoveBackground,
                        callback: function ($$v) {
                          _vm.isRemoveBackground = $$v
                        },
                        expression: "isRemoveBackground",
                      },
                    },
                    [_vm._v("\n        Remove background\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: { value: "true", "unchecked-value": "false" },
                      model: {
                        value: _vm.isCropToImage,
                        callback: function ($$v) {
                          _vm.isCropToImage = $$v
                        },
                        expression: "isCropToImage",
                      },
                    },
                    [_vm._v("\n        Crop to image\n      ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "ButtonOutline",
                    {
                      attrs: { variant: "outline-primary" },
                      on: {
                        click: function ($event) {
                          return _vm.$refs.modal.hide()
                        },
                      },
                    },
                    [_vm._v("\n        Cancel\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "ButtonPrimary",
                    {
                      attrs: {
                        variant: "primary",
                        disabled: !_vm.acceptButtonAvailable,
                      },
                      on: { click: _vm.accept },
                    },
                    [_vm._v("\n        Upload\n      ")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c("b-form-file", {
                attrs: { plain: "", multiple: "" },
                model: {
                  value: _vm.files,
                  callback: function ($$v) {
                    _vm.files = $$v
                  },
                  expression: "files",
                },
              }),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-4" },
                [
                  _vm.isCompanySelector
                    ? _c(
                        "b-col",
                        [
                          _c("label", { attrs: { for: "company-field" } }, [
                            _vm._v("Company"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form-select",
                            {
                              attrs: { id: "company-field" },
                              model: {
                                value: _vm.selectedCompany,
                                callback: function ($$v) {
                                  _vm.selectedCompany = $$v
                                },
                                expression: "selectedCompany",
                              },
                            },
                            _vm._l(_vm.companies, function (company) {
                              return _c(
                                "b-form-select-option",
                                {
                                  key: company.id,
                                  attrs: { value: company.id },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(company.name) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "image-type-field" } }, [
                        _vm._v("Image Type"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form-select",
                        {
                          attrs: { id: "image-type-field" },
                          model: {
                            value: _vm.type,
                            callback: function ($$v) {
                              _vm.type = $$v
                            },
                            expression: "type",
                          },
                        },
                        [
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "product_image" } },
                            [
                              _vm._v(
                                "\n              Product Image\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "stock_image" } },
                            [
                              _vm._v(
                                "\n              Stock Image\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isUploading
        ? _c("b-progress", {
            attrs: {
              value: _vm.uploadingProgress,
              "show-progress": "",
              animated: "",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }